module.exports = __webpack_public_path__ + "9378578dbbe8df170467abd880981232.svg";